import React from 'react';
import queryString from 'query-string';
import { QueryStringKeys, UTMSource, UTMMedium, UTMContent, UTMTerm, WagWebAppUrl } from '../../../../constants';
import { DownloadAppBouncer } from '../../../../components/DownloadAppBouncer';
export type DailyWagArticleBouncerProps = {
  slug: string;
};
export const DailyWagArticleBouncer = ({
  slug
}: DailyWagArticleBouncerProps) => {
  const getTheAppUrl = queryString.stringifyUrl({
    url: WagWebAppUrl.SignupFlow,
    query: {
      [QueryStringKeys.UTMSource]: UTMSource.Wag,
      [QueryStringKeys.UTMMedium]: UTMMedium.Web,
      [QueryStringKeys.UTMContent]: UTMContent.DailyWagBlog,
      [QueryStringKeys.UTMCampaign]: slug,
      [QueryStringKeys.UTMTerm]: UTMTerm.MobileBouncer
    }
  });
  return <DownloadAppBouncer display="flex" href={getTheAppUrl} data-sentry-element="DownloadAppBouncer" data-sentry-component="DailyWagArticleBouncer" data-sentry-source-file="index.tsx" />;
};